import { c as _c } from "react/compiler-runtime";
import { Either } from '@sola/schema/dotcom/helpers.ts';
export type LogoProps = Omit<React.ComponentPropsWithoutRef<'svg'>, 'aria-labelledby' | 'aria-hidden'> & Either<{
  'aria-hidden': true;
}, Either<{
  alt: string;
}, {
  'aria-labelledby': string;
}>>;
export const Logo: React.FC<LogoProps> = t0 => {
  const $ = _c(10);
  let alt;
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      alt,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = children;
    $[3] = props;
  } else {
    alt = $[1];
    children = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== alt) {
    t1 = alt && <title>{alt}</title>;
    $[4] = alt;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <svg fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>{t1}{children}</svg>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};